import { PATHS } from "~/const/paths";

export const OTHER_LINK = {
  id: "other",
  name: "グラビア・その他♡",
  path: { pathname: PATHS.VOD, query: { id: "other" } },
};
